"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dictionaryContentShape = exports.default = exports.countdownVariantPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const countdownVariantPropType = exports.countdownVariantPropType = _propTypes.default.shape({
  feature: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  label: _propTypes.default.bool,
  large: _propTypes.default.bool,
  noDivider: _propTypes.default.bool
});

// If a language dictionary entry is provided, it must contain every key
const dictionaryContentShape = exports.dictionaryContentShape = _propTypes.default.shape({
  days: _propTypes.default.string.isRequired,
  day: _propTypes.default.string.isRequired,
  hours: _propTypes.default.string.isRequired,
  hour: _propTypes.default.string.isRequired,
  minutes: _propTypes.default.string.isRequired,
  minute: _propTypes.default.string.isRequired,
  seconds: _propTypes.default.string.isRequired,
  second: _propTypes.default.string.isRequired
});
var _default = exports.default = {
  countdownVariantPropType,
  dictionaryContentShape
};